import { ThemeEvents } from '@theme/events';
class TlcBag extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.link = this.querySelector('.tlc-bag-link');
    this.notice = this.querySelector('.tlc-bag-notice');
    document.addEventListener(ThemeEvents.cartUpdate, event => this.update(event), options);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !this.notice.hidden) { event.preventDefault(); this.close(); }
    }, options);
    this.querySelector('[data-bag-close]').addEventListener('click', () => this.close(), options);
    window.addEventListener('pageshow', event => { if (event.persisted) this.refresh(); }, options);
  }
  disconnectedCallback() { this.controller.abort(); this.request?.abort(); }
  setCount(count) {
    this.querySelector('[data-bag-count]').textContent = count > 0 ? ` (${count})` : '';
    this.link.setAttribute('aria-label', this.dataset.countLabel.replace('__COUNT__', String(count)));
  }
  async refresh() {
    this.request?.abort();
    this.request = new AbortController();
    try {
      const response = await fetch(this.dataset.cartUrl, { signal: this.request.signal, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      this.setCount(cart.item_count);
    } catch (error) { if (error.name !== 'AbortError') console.error('Unable to refresh bag count', error); }
  }
  update(event) {
    const { resource, data = {} } = event.detail || {};
    this.request?.abort();
    if (Number.isInteger(resource?.item_count)) this.setCount(resource.item_count);
    else this.refresh();
    if (data.source !== 'product-form-component' || data.didError) return;
    this.returnFocus = document.activeElement;
    this.notice.hidden = false;
    requestAnimationFrame(() => { if (this.isConnected && !this.notice.hidden) this.notice.focus({ preventScroll: true }); });
  }
  close() {
    this.notice.hidden = true;
    const target = this.returnFocus;
    if (target instanceof HTMLElement && target.isConnected && target.checkVisibility()) target.focus({ preventScroll: true });
    else this.link.focus({ preventScroll: true });
  }
}
if (!customElements.get('tlc-bag')) customElements.define('tlc-bag', TlcBag);
